import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const InterestIcon = ({ label = 'Interest', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><rect x="36.7" y="38.4" width="223.5" height="223.53" rx="21.5" style="fill:#84cee3"/><path d="M238.7 38.4a21.6 21.6 0 0 1 21.5 21.5v180.6a21.6 21.6 0 0 1-21.5 21.5H58.2a21.6 21.6 0 0 1-21.5-21.5V59.9a21.6 21.6 0 0 1 21.5-21.5h180.5m0-10H58.2a31.6 31.6 0 0 0-31.5 31.5v180.6A31.6 31.6 0 0 0 58.2 272h180.5a31.6 31.6 0 0 0 31.5-31.5V59.9a31.6 31.6 0 0 0-31.5-31.5z" style="fill:#1d1d1b"/><ellipse cx="110.4" cy="116.6" rx="17.1" ry="25.8" style="fill:#84cee3"/><ellipse cx="179.6" cy="116.6" rx="17.1" ry="25.8" style="fill:#84cee3"/><path d="M67.4 171.2a83.8 83.8 0 0 0 14.1 22.2 89.8 89.8 0 0 0 42.9 27.3 88.1 88.1 0 0 0 51.2 0 89.8 89.8 0 0 0 42.9-27.3 83.8 83.8 0 0 0 14.1-22.2l-7.4-5.8q-16.5 17.7-33.7 26.5c-11.6 6-25.4 9-41.5 9s-29.9-3-41.5-9-22.7-14.7-33.7-26.5zM91 115.3c0 8.1 2 15 6 20.8s8.9 8.6 14.7 8.6 10.7-2.9 14.7-8.6 6-12.7 6-20.8-2-15-6-20.8-8.9-8.8-14.7-8.8S101 88.6 97 94.5s-6 12.8-6 20.8zm76.6 0c0 8.1 2 15 6 20.8s8.9 8.6 14.7 8.6 10.7-2.9 14.7-8.6 6-12.7 6-20.8-2-15-6-20.8-8.9-8.8-14.7-8.8-10.7 2.9-14.7 8.8-6 12.8-6 20.8z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

InterestIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { InterestIcon }
